/** Client-spezifische Konstanten (geteilte liegen in @etown/shared). */

/** Feste Simulationsrate des lokalen Spiels. */
export const SIM_STEP_MS = 1000 / 60;

/** Kamera folgt dem Spieler mit diesem Glaettungsfaktor pro Frame. */
export const CAMERA_LERP = 0.12;

/** Standard-Zoom (Welt-Pixel -> Screen-Pixel). */
export const CAMERA_ZOOM = 1.25;

/** Frequenz der lokalen UX-Proximity-Pruefung (Objekte, Audio-Gain). */
export const HINT_CHECK_HZ = 10;

/** Schwelle, ab der eine Server-Korrektur uebernommen wird (Tiles). */
export const CORRECTION_THRESHOLD_TILES = 0.75;

/** Geschwindigkeit, mit der zur Server-Position zurueckgeglitten wird. */
export const CORRECTION_LERP = 0.25;

/** Chat: maximal im Speicher gehaltene Nachrichten. */
export const CHAT_BUFFER_LIMIT = 300;

/** "Abgelehnt"-Anzeige an der Bubble faellt nach dieser Zeit auf normal zurueck. */
export const RING_DECLINED_RESET_MS = 5000;
